import { render, staticRenderFns } from "./document-classification-collapse.vue?vue&type=template&id=7f7b55e0"
import script from "./document-classification-collapse.vue?vue&type=script&lang=js"
export * from "./document-classification-collapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7b55e0')) {
      api.createRecord('7f7b55e0', component.options)
    } else {
      api.reload('7f7b55e0', component.options)
    }
    module.hot.accept("./document-classification-collapse.vue?vue&type=template&id=7f7b55e0", function () {
      api.rerender('7f7b55e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/documents/components/document-classification-collapse.vue"
export default component.exports